document.addEventListener("DOMContentLoaded", () => {
    const viewDesktop = document.querySelector('.collection-swiper-slider-container').dataset.view;
const infiniteLoop = document.querySelector('.collection-swiper-slider-container').dataset.forloop;

var mySwiper = new Swiper('.swiper-container.collection-swiper-slider-container', {  
    spaceBetween: 8,  
    slidesPerView: 1,  
    slidesCenter: true,
    grabCursor: true,  
    freeMode: true,  
    loop: infiniteLoop, 
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {  
        640: { 
            slidesPerView: 1,  
            spaceBetween: 24  
        },  
        768: { 
            slidesPerView: 2, // Set this to a number if you want specific counts  
            spaceBetween: 12 // Add space between slides  
        },  
        1024: { 
            slidesPerView: 2, // Set this to a number if you want specific counts  
            spaceBetween: 12 // Add space between slides  
        },  
        1400: { 
            slidesPerView: viewDesktop,  
            spaceBetween: 24 // Ensure space between is set  
        }  
    },
     
});
})
